var _defs, _rect, _rect2, _g, _g2, _g3, _path, _path2, _path3, _polygon, _path4, _path5, _polyline, _polyline2, _polygon2, _path6, _line, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path11, _polygon3, _polygon4, _path12, _line2, _path13, _line3, _path14, _polyline3, _path15, _path16, _polygon5, _line4, _path17, _path18, _path19, _path20, _ellipse5, _circle, _circle2, _ellipse6, _ellipse7, _ellipse8, _path21, _path22, _path23, _path24, _path25, _g4, _g5, _g6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShowersbefore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    viewBox: "0 0 1258 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "showers_before_svg__clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "816.7 703.95 816.7 945.01 1260.04 928.78 1260.04 691.33 816.7 703.95",
    className: "showers_before_svg__cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "showers_before_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1362.83 698.09 851.46 660.88 851.46 270.94 1347.51 270.94 1362.83 698.09",
    className: "showers_before_svg__cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "showers_before_svg__clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 408.59,
    height: 184.19,
    x: 851.79,
    y: -6.62,
    className: "showers_before_svg__cls-1"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n   .showers_before_svg__cls-1,.showers_before_svg__cls-24,.showers_before_svg__cls-36,.showers_before_svg__cls-37{fill:none}.showers_before_svg__cls-38{fill:#4f4f4e}.showers_before_svg__cls-14,.showers_before_svg__cls-17,.showers_before_svg__cls-21,.showers_before_svg__cls-22,.showers_before_svg__cls-23,.showers_before_svg__cls-25,.showers_before_svg__cls-27,.showers_before_svg__cls-28,.showers_before_svg__cls-29,.showers_before_svg__cls-35,.showers_before_svg__cls-36,.showers_before_svg__cls-37,.showers_before_svg__cls-38,.showers_before_svg__cls-40,.showers_before_svg__cls-7{stroke:#343a50}.showers_before_svg__cls-14,.showers_before_svg__cls-17,.showers_before_svg__cls-21,.showers_before_svg__cls-22,.showers_before_svg__cls-23,.showers_before_svg__cls-24,.showers_before_svg__cls-25,.showers_before_svg__cls-27,.showers_before_svg__cls-28,.showers_before_svg__cls-37,.showers_before_svg__cls-38,.showers_before_svg__cls-40,.showers_before_svg__cls-7{stroke-miterlimit:10}.showers_before_svg__cls-5{fill:#eb9a6b}.showers_before_svg__cls-6{fill:#343a50}.showers_before_svg__cls-7{fill:#7fc3ca}.showers_before_svg__cls-14,.showers_before_svg__cls-17,.showers_before_svg__cls-36,.showers_before_svg__cls-37,.showers_before_svg__cls-40,.showers_before_svg__cls-7{stroke-width:2px}.showers_before_svg__cls-42{fill:#dedede}.showers_before_svg__cls-29,.showers_before_svg__cls-35,.showers_before_svg__cls-36,.showers_before_svg__cls-37{stroke-linecap:round}.showers_before_svg__cls-29,.showers_before_svg__cls-35,.showers_before_svg__cls-36{stroke-linejoin:round}.showers_before_svg__cls-11,.showers_before_svg__cls-17,.showers_before_svg__cls-21,.showers_before_svg__cls-46{fill:#fff}.showers_before_svg__cls-14{fill:#7e7e7e}.showers_before_svg__cls-16{fill:#91bec3}.showers_before_svg__cls-21{stroke-width:1.97px}.showers_before_svg__cls-22{fill:#191919}.showers_before_svg__cls-22,.showers_before_svg__cls-23,.showers_before_svg__cls-25,.showers_before_svg__cls-27,.showers_before_svg__cls-28,.showers_before_svg__cls-29,.showers_before_svg__cls-35{stroke-width:3px}.showers_before_svg__cls-23{fill:#857d7a}.showers_before_svg__cls-24{stroke:#191919;stroke-width:5.98px}.showers_before_svg__cls-25{fill:#f84c34}.showers_before_svg__cls-27,.showers_before_svg__cls-35{fill:#ffccb5}.showers_before_svg__cls-28{fill:#754e3e}.showers_before_svg__cls-29{fill:#3f4a74}.showers_before_svg__cls-31{fill:#343a51}.showers_before_svg__cls-38{stroke-width:3.15px}.showers_before_svg__cls-40{fill:#010101}.showers_before_svg__cls-42{opacity:.51;mix-blend-mode:multiply}.showers_before_svg__cls-46{opacity:.32}.showers_before_svg__cls-47{fill:#89bb21}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "showers_before_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "showers_before_svg__Unternehmerduschen_Vorher"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "showers_before_svg__Boden",
    width: 1261.02,
    height: 267.5,
    x: -1.51,
    y: 814,
    fill: "#4f4f4e",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "showers_before_svg__Himmel",
    width: 804.72,
    height: 812.51,
    fill: "#a5d1d6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "showers_before_svg__Haus-hinten"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1179.15,
    height: 678.22,
    x: -0.98,
    y: 134.9,
    className: "showers_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.18 135.9v676.22H0V135.9h1177.18m2-2H-2v680.21h1181.18V133.9z",
    className: "showers_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 313.62,
    height: 510.36,
    x: 528.48,
    y: 188.81,
    className: "showers_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "667.7 699.15 667.7 461.57 528.42 461.57 528.42 426.4 667.7 426.4 667.7 188.77 702.87 188.77 702.87 426.4 841.23 426.4 841.23 461.57 702.87 461.57 702.87 699.15 667.7 699.15",
    className: "showers_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.87 189.77V427.4h138.36v33.17H701.87v237.59H668.7V460.57H529.42V427.4H668.7V189.77h33.17m2-2H666.7v237.64H527.43v37.16H666.7v237.58h37.16V462.57h138.37v-37.16H703.86V187.77z",
    className: "showers_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 288.45,
    height: 510.36,
    x: 889.92,
    y: 188.81,
    className: "showers_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.16,
    height: 508.36,
    x: 1029.15,
    y: 189.81,
    className: "showers_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.31 190.81v506.36h-33.16V190.81h33.16m2-2h-37.16v510.36h37.16V188.81z",
    className: "showers_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 286.59,
    height: 35.16,
    x: 890.79,
    y: 426.41,
    className: "showers_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.38 427.41v33.16H891.79v-33.16h284.59m2-2H889.79v37.16h288.59v-37.16z",
    className: "showers_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 454.24,
    height: 589.76,
    x: -0.98,
    y: 223.35,
    fill: "#db8356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.26 224.35v587.77H0V224.35h452.26m2-2H-2v591.76h456.25V222.35z",
    className: "showers_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 399.35,
    height: 553.82,
    x: -0.98,
    y: 259.29,
    fill: "#cc7650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.37 260.29v551.83H0V260.29h397.37m2-2H-2v555.82h401.37V258.29z",
    className: "showers_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 258.35,
    height: 520.81,
    x: 67.62,
    y: 293.3,
    className: "showers_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.68 814.62 187.68 682.42 67.58 682.42 67.58 664.19 187.68 664.19 187.68 545.32 67.57 545.32 67.57 527.09 187.68 527.09 187.68 408.59 67.57 408.59 67.57 390.35 187.68 390.35 187.68 293.28 205.91 293.28 205.91 390.35 326 390.35 326 408.59 205.91 408.59 205.91 527.09 326 527.09 326 545.32 205.91 545.32 205.91 664.19 326 664.19 326 682.42 205.91 682.42 205.91 814.62 187.68 814.62",
    className: "showers_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.91 294.28v97.07H325v16.24H204.91v120.5H325v16.23H204.91v120.87H325v16.23H204.91v132.2h-16.24v-132.2H68.58v-16.23h120.09V544.32H68.57v-16.23h120.1v-120.5H68.57v-16.24h120.1v-97.07h16.24m2-2h-20.24v97.07H66.57v20.24h120.1v116.5H66.57v20.23h120.1v116.87H66.58v20.23h120.09v132.2h20.24v-132.2H327v-20.23H206.91V546.32H327v-20.23H206.91v-116.5H327v-20.24H206.91v-97.07z",
    className: "showers_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.85,
    x2: 398.11,
    y1: 223.93,
    y2: 259.28,
    fill: "#dedede",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "showers_before_svg__Haus-vorne"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "showers_before_svg__Wand",
    width: 452.52,
    height: 811,
    x: 805.48,
    className: "showers_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "showers_before_svg__Posten-hochformat",
    width: 20.94,
    height: 931.32,
    x: 794.88,
    y: -1,
    fill: "#815c2a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "showers_before_svg__Mauer",
    clipPath: "url(#showers_before_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 794.65,
    y: 703.92,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 863.33,
    y: 703.92,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 932.01,
    y: 703.92,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 1000.7,
    y: 703.92,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 1069.38,
    y: 703.92,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 1138.06,
    y: 703.92,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1259.09 759.63 1206.75 759.63 1206.75 703.92 1259 703.92 1259.09 759.63",
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 760.31,
    y: 759.63,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 828.99,
    y: 759.63,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 897.67,
    y: 759.63,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 966.36,
    y: 759.63,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 1035.04,
    y: 759.63,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 1103.72,
    y: 759.63,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 1172.41,
    y: 759.63,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1259 815.34 1241.09 815.34 1241.09 759.63 1259.09 759.63 1259 815.34",
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 794.65,
    y: 815.34,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 863.33,
    y: 815.34,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 932.01,
    y: 815.34,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 1000.7,
    y: 815.34,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 1069.38,
    y: 815.34,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 1138.06,
    y: 815.34,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52.25,
    height: 55.71,
    x: 1206.75,
    y: 815.34,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 760.31,
    y: 871.05,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 828.99,
    y: 871.05,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 897.67,
    y: 871.05,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 966.36,
    y: 871.05,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 1035.04,
    y: 871.05,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 1103.72,
    y: 871.05,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: 1172.41,
    y: 871.05,
    className: "showers_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1259.04 926.75 1241.09 926.75 1241.09 871.05 1259 871.05 1259.04 926.75",
    className: "showers_before_svg__cls-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "showers_before_svg__Fesnter-unten"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#showers_before_svg__clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 406.57,
    height: 387.95,
    x: 852.46,
    y: 271.94,
    className: "showers_before_svg__cls-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 272.94v386H853.46v-386H1258m2-2H851.46v389.94H1260V270.94z",
    className: "showers_before_svg__cls-6"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1259 450.18 1212.21 450.18 1212.21 271.94 1183.24 271.94 1183.24 450.18 1022.47 450.18 1022.47 271.96 993.4 271.96 993.5 450.18 852.45 450.18 852.45 479.14 993.5 479.14 993.5 659.86 1022.47 659.86 1022.47 479.14 1183.24 479.14 1183.24 659.86 1212.21 659.86 1212.21 479.14 1259 479.14 1259 450.18",
    className: "showers_before_svg__cls-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "showers_before_svg__Posten-querformat",
    fill: "#815c2a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 815.62,
    x2: 1259.03,
    y1: 219.58,
    y2: 219.58
  }), /*#__PURE__*/React.createElement("rect", {
    width: 443.15,
    height: 16.99,
    x: 815.88,
    y: 211.08
  })), /*#__PURE__*/React.createElement("g", {
    id: "showers_before_svg__Fesnter-oben"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#showers_before_svg__clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 405.78,
    height: 175.49,
    x: 853.22,
    y: -0.99,
    className: "showers_before_svg__cls-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 0v173.5H854.22V0H1258m2-2H852.22v177.5H1260V-2z",
    className: "showers_before_svg__cls-6"
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "993.33 0 993.33 174.5 1022.3 174.5 1022.3 0",
    className: "showers_before_svg__cls-21"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1183.07 0 1183.07 174.5 1212.04 174.5 1212.04 0",
    className: "showers_before_svg__cls-21"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "showers_before_svg__Fahrrad"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.98,
    height: 10,
    x: 394.34,
    y: 767.05,
    className: "showers_before_svg__cls-22",
    rx: 4.14
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.96 818.67 374.32 813.71 406.06 772.06 413.67 772 379.96 818.67",
    className: "showers_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.48 819.87 152.51 757.33 159.41 750.95 223.38 813.49 216.48 819.87",
    className: "showers_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.25,
    cy: 822.37,
    r: 28.75,
    className: "showers_before_svg__cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.62 814.32c2 8.26-.92 37.26-27.14 36.8-13.17-.24-167.9-10.81-162.84-36.8 3.59-18.4 108.35-20.7 162.84-20.7 0 0 22.08 0 27.14 20.7z",
    className: "showers_before_svg__cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.4 909.15a95.28 95.28 0 1195.28-95.28 95.38 95.38 0 01-95.28 95.28zm0-181.47a86.19 86.19 0 1086.19 86.19 86.29 86.29 0 00-86.19-86.19z",
    className: "showers_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.73 812.71 527.98 731.6 536.68 728.07 574.43 809.17 565.73 812.71",
    className: "showers_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3 917.48a103.62 103.62 0 1173.28-30.35 102.94 102.94 0 01-73.28 30.35zm0-198.26a94.64 94.64 0 1094.64 94.64 94.74 94.74 0 00-94.64-94.64zM571 917.48a103.62 103.62 0 1173.28-30.35A102.94 102.94 0 01571 917.48zm0-198.26a94.64 94.64 0 1094.64 94.64A94.74 94.74 0 00571 719.22z",
    className: "showers_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606 703.65a113.63 113.63 0 00-82 4.83l-7.79-19.17a4.52 4.52 0 00-1-4.41 4.82 4.82 0 00-1.09-.84l-4.76-11.7a4.45 4.45 0 00-.13-3.05L493 630.21a4.5 4.5 0 10-8.31 3.43l13.64 33.13-162.52 6.07-10.08-35.57a4.5 4.5 0 00-8.65 2.45l10.41 36.76L291.6 722a113.3 113.3 0 00-150.16 9.66 114.32 114.32 0 00-33.33 81.06 5.64 5.64 0 0011.27 0c0-57 46-103.39 102.58-103.39a101.59 101.59 0 0162.62 21.55l-66 83.65a4.5 4.5 0 003.3 7.28l146.28 7.36H368.99l.32-.06h.15l.31-.09.14-.05.3-.12.13-.06.31-.16.1-.06.33-.23h.06a3.27 3.27 0 00.35-.3L511 695l6.72 16.54a114.94 114.94 0 00-60.35 101.26 5.63 5.63 0 0011.26 0c0-57 46-103.39 102.59-103.39a101.75 101.75 0 0131.33 4.92 5.63 5.63 0 103.45-10.68zm-314.57 33.06a103.46 103.46 0 0133.11 76 5.65 5.65 0 004.32 5.47L231 813.25zm39.5 81.57a5.63 5.63 0 004.88-5.57 114.32 114.32 0 00-33.33-81.06q-2-2-4-3.85l31.82-40.31 32.27 132.38zm39.95-2.23l-32.73-134.3 164.93-6.15 4.26 10.48z",
    className: "showers_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.85,
    x2: 334.02,
    y1: 818.02,
    y2: 818.44,
    className: "showers_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570.98,
    cy: 813.86,
    r: 8.97,
    className: "showers_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.79 908.1a95.28 95.28 0 1195.28-95.28 95.38 95.38 0 01-95.28 95.28zm0-181.47A86.19 86.19 0 10658 812.82a86.29 86.29 0 00-86.21-86.19z",
    className: "showers_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M277.31 644.15a10.65 10.65 0 01-5.61-5.26c-1.77-3.9-.91-8.37-.2-12.07.57-3 2.27-11.86 8.61-17.33 3.57-3.08 6.91-3.63 10.41-4.2a26.84 26.84 0 0118 2.89c7.32 4.12 8 9 15.77 11.68 2.31.78 4.09.89 7.66 1.18 9.95.82 15.62-1.53 26.83-.52 6.28.56 8.19 1.63 9.21 3.67 1.78 3.55.47 9.16-1.4 12.6-3.46 6.38-9.95 7.35-16.82 8.14-11.62 1.34-17.55 1.19-34.26 2.18-5.06.3-5.62.44-11 .71-9.58.49-18.45.59-27.2-3.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.27 555.44c.58-.57-2.34 3.55-3.42 7.43l-18 62-48 37c-3.28 2.35-6.35 2.73-4 6 1.42 2 1.33 1.94 3.6 1.94a7.3 7.3 0 004.25-1.36l46.83-33.6 6.36 14.93 9.31-4-8.87-20.78 17-60.52c1.08-3.92-7.93-6.21-5.06-9.04z",
    className: "showers_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.25,
    cy: 822.83,
    r: 8.97,
    className: "showers_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.55,
    height: 7.36,
    x: 340.4,
    y: 841,
    className: "showers_before_svg__cls-23",
    transform: "rotate(-64.16 364.72 844.712)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.64,
    height: 13.34,
    x: 336.84,
    y: 861.7,
    className: "showers_before_svg__cls-22",
    rx: 5.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 495.54,
    x2: 504.12,
    y1: 583.4,
    y2: 555.89,
    className: "showers_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.44 587.37l-11.09-5.09 4.64-21.9c.95-4.51 4.21-7 7.27-5.62 3.07 1.41 4.78 6.2 3.82 10.71z",
    className: "showers_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 449.07,
    x2: 433.85,
    y1: 651.96,
    y2: 665.87,
    className: "showers_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.29 648.05l4.65 10.71-16.94 11.6c-3.49 2.39-7.35 1.93-8.64-1-1.28-3 .5-7.29 4-9.67z",
    className: "showers_before_svg__cls-25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "showers_before_svg__Mann"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M740.94 979.59a246.87 246.87 0 01-7.35-81.27l17.63-15.48A62.12 62.12 0 01763 899.61c5.87 12.5 4.77 22.21 4.4 49-.09 6.94-.18 17.65 0 31",
    className: "showers_before_svg__cls-27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M713.53 617.74c-7.24-1.25-15.44 5.29-19.35 10.32-7.6 9.78-3.26 19.32-3.87 47.73-.42 19.43-2.52 18.31-2.58 37.41-.07 22.09 0 33.32 6.45 42.57 7.63 11 24.33 21.19 34.83 16.77 30.32-12.75 14.26-149.66-15.48-154.8z",
    className: "showers_before_svg__cls-28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M799.25 979.24A246.87 246.87 0 01791.9 898l17.63-15.48a62.12 62.12 0 0111.76 16.77c5.87 12.51 4.77 22.21 4.4 49-.09 7-.17 17.65 0 31",
    className: "showers_before_svg__cls-27"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "734.99 773.83 822.53 771.9 826.81 911.45 790.16 917.83 770.24 808.82 770.24 894.2 728.36 894.2 728.36 773.19 734.99 773.83",
    className: "showers_before_svg__cls-29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f4a74",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M822.53 770.61l12.26-140.11a16.63 16.63 0 00-16.63-16.63h-88a16.63 16.63 0 00-16.62 16.63l14.83 141.4 74.16-1a22.57 22.57 0 015.18 5.53c3 4.63 2.52 7.73 5.16 10.32 3 3 8.37 4.65 11.61 2.58a6.17 6.17 0 002.58-3.87c.38-2.48-1.33-4.32-2.58-6.45-1.08-1.83-1.62-4.52-1.95-8.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M734.17 871.87c-3.46-.6-6-1.48-7.74 0-1.39 1.22-1.37 3.29-1.29 6.45.17 7 2.66 8.92 1.29 12.9-.68 2-1.7 2.69-1.29 3.87.62 1.8 3.72 2.29 6.45 2.58 7.55.81 11 0 16.77 0 7 0 7.16 1.32 15.48 1.29 9.88 0 11.22-1.84 11.61-2.58 1-2-.92-3.35-1.29-9-.31-4.64.89-5.39 0-7.74-1.49-3.9-6.21-5.49-9-6.45-2-.68-4.1-1.13-14.19-1.29-14.78-.26-12.81.67-16.8-.03zM809.63 890.58c-5.84.66-7.19-2.05-14.19-2.58-4.22-.32-12.56 0-14.19 3.87-.91 2.16 1.32 2.94 2.58 9 .65 3.11.32 4.1 1.29 12.9.39 3.52.55 4.33 1.29 5.16.46.5 2.16 2.17 10.32 1.29 5-.55 6.33-1.39 12.9-2.58 3.07-.56 5.34-.84 9-1.29 11-1.35 13.28-.87 14.19-2.58 1.58-2.95-4.32-6.17-3.87-12.9.33-4.89 3.66-6.34 2.58-9-1.39-3.5-8.3-4.36-12.9-3.87s-4.63 2.08-9 2.58z",
    className: "showers_before_svg__cls-29"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "763.19 609.36 750.53 617.5 753.47 627.6 744.49 644.83 763.19 700.95",
    className: "showers_before_svg__cls-31"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "790.39 609.65 799.19 619.73 796.26 629.83 805.24 647.06 786.54 703.18",
    className: "showers_before_svg__cls-31"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    points: "784.48 771.9 762.55 771.9 762.55 608.71 789.64 612.58 784.48 771.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M763.84 597.1c-.57 2.79-3.71 19.48 6.45 29.67a22.66 22.66 0 005.16 3.87l2.58-1.29c2.07-1.41 9.54-6.87 11.61-16.77a25.59 25.59 0 000-10.32",
    className: "showers_before_svg__cls-27"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 775.45,
    x2: 773.51,
    y1: 630.64,
    y2: 772.54,
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9079",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M843.82 496.48c.06-1-1.68-1.31-3.87-3.87-2.7-3.15-2.3-5.28-3.87-6.45-1.05-.78-2.9-1.05-6.33.33A45.9 45.9 0 00818 474.22c-9.19-7-18.22-8.62-26-10.06a82.07 82.07 0 00-28.55 0c-1.4-2.6-3.77-5.65-7.39-6.39-.57-.11-4.45-.84-6.45 1.29-1 1.09-1 2.39-1.29 3.87a20.3 20.3 0 01-2.13 6.19 35.5 35.5 0 00-4.5 2.58 44.73 44.73 0 00-14.25 15.93c-3.06 5.48-4.18 10-5.87 16.77-.52 2.09-1.44 5.92-2.22 11a10.87 10.87 0 00-.86 18.85c.21 1.94.46 3.69.56 5.34l10.06.84 8.39-24.31 13.5-14.43 15.94 4.39L782.82 517l20.09 7.2 23.69 18 9-2.52c-.06-6.75 0-9.26.07-13.88.08-8.81.22-11-.07-15.46-.27-4.17-.49-7.45-1-10.46 7.45-1.23 9.16-2.45 9.22-3.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M727.2 566.81c-8.05-1.63-14-7.18-14-13.77 0-6.44 5.65-11.88 13.41-13.65M827.48 567c8-1.63 14-7.18 14-13.77 0-6.44-5.65-11.89-13.41-13.65",
    className: "showers_before_svg__cls-27"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M757.66 487.64a49.68 49.68 0 00-14.25 7.54c-15 12.54-16.57 32-16.77 37.74v4.19c0 11-.15 23.58.84 32.7a41.79 41.79 0 00.84 5 46.67 46.67 0 002.51 7.55c3.61 8 11.88 14.55 12.58 15.09a50.76 50.76 0 0020.12 9.22c6.06 1.45 16.36 4.06 27.67 0 2.78-1 5.62-2.75 11.32-6.28a87.42 87.42 0 0019.29-15.94c2.88-3.25 4.66-5.87 5-9.22.12-1.06 0-1.72 0-5.87v-6.71c0-4.56.3-19 .84-38.57a49.37 49.37 0 00-5-2.51 47.69 47.69 0 00-7.55-2.52c-7.3-1.83-20.86-9.74-38.57-20.12-5.56-3.26-10-5.94-15.09-9.23-4-2.59-7.45-4.9-10.07-6.7",
    className: "showers_before_svg__cls-35"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M742.57 522.85a12 12 0 016.71-4.19 12.46 12.46 0 0110.06 2.52M795 524.18a12 12 0 016.71-4.19 12.41 12.41 0 0110.06 2.52M792 585a25.18 25.18 0 00-8.28-3.6 24.89 24.89 0 00-10.06-.31 23.89 23.89 0 00-9.34 3.92M770.24 563.94a7.56 7.56 0 0014.25 0",
    className: "showers_before_svg__cls-36"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 750.95,
    cy: 541.72,
    className: "showers_before_svg__cls-11",
    rx: 8.39,
    ry: 6.29
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 803.78,
    cy: 541.72,
    className: "showers_before_svg__cls-11",
    rx: 8.39,
    ry: 6.29
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 750.54,
    cy: 542.14,
    className: "showers_before_svg__cls-6",
    rx: 2.93,
    ry: 4.19
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 803.36,
    cy: 541.3,
    className: "showers_before_svg__cls-6",
    rx: 2.93,
    ry: 4.19
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M719.93 550.52a9.37 9.37 0 012.52-.83 9.24 9.24 0 013.35 0M832.29 558.07a4 4 0 001.68-2.51c.34-2.36-2.21-4-2.52-4.2a6.22 6.22 0 00-4.19-.84",
    className: "showers_before_svg__cls-37"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "737.27 963.33 767.71 963.33 767.71 975.92 753.52 982.81 744.49 980.23 740.46 977.72 737.27 963.33",
    className: "showers_before_svg__cls-28"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "795.96 962.82 826.4 962.82 826.4 975.41 812.21 982.3 803.18 979.72 799.15 977.21 795.96 962.82",
    className: "showers_before_svg__cls-28"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M792.22 992.63c0-11.83 9.09-21.43 20.32-21.43s20.31 9.6 20.31 21.43",
    className: "showers_before_svg__cls-28"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 790.28,
    x2: 834.79,
    y1: 993.13,
    y2: 993.13,
    className: "showers_before_svg__cls-38"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M734.71 994.2c0-11.84 9.1-21.43 20.32-21.43s20.32 9.59 20.32 21.43",
    className: "showers_before_svg__cls-28"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 732.78,
    x2: 777.28,
    y1: 994.7,
    y2: 994.7,
    className: "showers_before_svg__cls-38"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M693.52 749.54c-3.92 3.62-5.14 8.16-6.37 13-1.4 5.47-2.1 8.21-1.21 10.65 1.86 5.11 8.37 9 13.29 7.79 7.46-1.82 9.77-14.76 10.37-14.76.44 0-.23 6.75 2.53 11.41.79 1.34 1.86 3 3.9 2.14 3.76-1.52 1.81-4 1.53-6.58-.38-3.67-.07-4.26-.66-7.58-.85-4.82.19-5.87-1-9.11-.5-1.39-3.38-3.1-9.12-6.48-4.95-2.91-6.36-3.54-8.23-3.29a9.17 9.17 0 00-5.03 2.81z",
    className: "showers_before_svg__cls-35"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "716.13 622.37 712.9 631.79 692.41 748.31 716.13 757.94 734.17 656.44",
    className: "showers_before_svg__cls-29"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M831.94 621.24l4.66 8.8L874.93 742l-3.93 2.33-18 10.83q-16.8-48.74-33.59-97.46",
    className: "showers_before_svg__cls-29"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M740.19 509.07c-1.6-.08-1.66 5.9-5.14 15.36a7.89 7.89 0 00-.45 4.37c.4 1.92 1.81 4.42 3.91 4.83 3.08.58 6.48-3.54 6.94-7.23.21-1.67-.25-2.69-1.2-5.43-3.17-9.11-2.97-11.86-4.06-11.9zM727.49 533.94c-1.61-.07-1.66 5.92-5.15 15.41a7.78 7.78 0 00-.46 4.38c.4 1.92 1.82 4.43 3.93 4.83 3.08.59 6.49-3.54 7-7.24.21-1.67-.25-2.7-1.2-5.44-3.22-9.13-3.03-11.88-4.12-11.94zM824 547.72c-1.52-.07-1.57 5.58-4.86 14.53a7.41 7.41 0 00-.43 4.14c.38 1.81 1.71 4.18 3.7 4.56 2.91.56 6.13-3.35 6.57-6.83.19-1.58-.24-2.55-1.14-5.14-2.97-8.62-2.79-11.22-3.84-11.26zM822.72 524.83c-1.18-.05-1.22 4.34-3.78 11.31a5.81 5.81 0 00-.34 3.21c.3 1.42 1.34 3.26 2.88 3.56 2.27.43 4.77-2.61 5.11-5.32.16-1.23-.18-2-.88-4-2.33-6.7-2.19-8.73-2.99-8.76z",
    className: "showers_before_svg__cls-17"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "817.37 673.53 816.08 667.09 812.21 670.96 805.76 663.22 803.18 672.25 817.37 673.53",
    className: "showers_before_svg__cls-11"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 803.18,
    x2: 817.37,
    y1: 673.86,
    y2: 673.86,
    fill: "none",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M747.71 611.24a2.28 2.28 0 010 2c-1.62 39.71-7.5 70.29-12.9 91.59-1.16 4.59-7.77 30.65-10.32 30.19-1.72-.31-1-12.62 0-23.74a249.89 249.89 0 007.74-96.75 3.15 3.15 0 010-2.58c.46-.77 1.33-1.06 2.58-1.29 3.57-.67 4.72.08 9 0 2.04-.05 3.35-.24 3.9.58z",
    className: "showers_before_svg__cls-28"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M870.26 738.36c1.71.83 3.72 3.56 7.74 9 3.41 4.62 3.73 5.8 3.87 6.45 1.28 5.9-3.47 11.18-3.87 11.61-4.34 4.69-12.25 7-18.06 3.87-5.41-2.91-6.57-9.21-7.74-15.48-.73-4-1.18-6.37 0-9 2.74-6.16 12.27-9.27 18.06-6.45z",
    className: "showers_before_svg__cls-35"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M914.55 828.16a26 26 0 01-9.4 4.12 26.49 26.49 0 01-5.51.54 71.48 71.48 0 00-14.2 1.85v-1.55c0-.81-.4-3.25-1.17-8.12-.66-4.23-.84-4.89-1.1-6.92a69.15 69.15 0 01-.52-9.6l-4 1.19a91.71 91.71 0 00.79 14.39c.74 5.54 1.47 7.19 1.51 10 .06 4.34-1.5 10.56-9.11 18.3l3.59 3.9a24 24 0 002.05-2 25.52 25.52 0 004.62-8A56.33 56.33 0 00885 838h3.63c10.82-.2 15.45-.93 18.21-1.48a26.08 26.08 0 007.83-2.74 23.87 23.87 0 002.13-1.31z",
    className: "showers_before_svg__cls-40"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M929.89 836c3.15-1.72 5.39-4.3 7.94-8.85 4.11-7.34 9.74-17.38 7.25-30.24a37 37 0 00-5.8-13.64c-7.42-10.8-18.91-15-23.77-16.75-3.76-1.37-3.72-.9-9.3-2.86-6.18-2.17-8.4-3.51-16.48-6.56-7.24-2.72-9-3-9.8-3.07a32.28 32.28 0 00-12.21 1.15 44.38 44.38 0 00-12.72 5c-7.62 4.53-17.37 13.6-15.32 19.13a5 5 0 001.06 1.63 4.79 4.79 0 002.11 1.2 133.35 133.35 0 0118.24 7.91c4.16 2.3 5.38 3.77 5.76 4.26a19.29 19.29 0 013.29 7.28c.2 1 .12 1 .34 1.91a13.78 13.78 0 002.73 5.86c2.75 3 7.15 2.94 8.1 2.93 3.41-.06 3.91-1.49 8.06-2.37a23 23 0 019.87.19c2.65.64 8 1.95 10.7 6.39 1.15 1.93 1.6 4.77 2.49 10.45.4 2.51.44 3.61 1.25 5.23a11.2 11.2 0 005.34 5.24c4.66 1.98 9.34-.59 10.87-1.42z",
    className: "showers_before_svg__cls-25"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 852.82,
    cy: 768.61,
    className: "showers_before_svg__cls-40",
    rx: 7.25,
    ry: 2.69,
    transform: "rotate(-56.27 852.753 768.588)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 880.65,
    cy: 802.34,
    r: 2.69,
    className: "showers_before_svg__cls-40"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 922.39,
    cy: 826.29,
    r: 2.69,
    className: "showers_before_svg__cls-40"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 918.88,
    cy: 777.63,
    className: "showers_before_svg__cls-40",
    rx: 2.69,
    ry: 9.4,
    transform: "rotate(-32.43 918.763 777.583)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 904.72,
    cy: 770.69,
    className: "showers_before_svg__cls-40",
    rx: 2.69,
    ry: 7.85,
    transform: "rotate(-32.9 893.159 768.714)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 890.85,
    cy: 763.97,
    className: "showers_before_svg__cls-40",
    rx: 1.84,
    ry: 7.75,
    transform: "rotate(-32.43 890.739 763.914)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M853 757.12l3 14.78a2.67 2.67 0 00.24 1.18 3.6 3.6 0 004.49 1.49 3.88 3.88 0 001.86-2.63c.45-1.56.07-2.89-.55-4.94-.81-2.72-1.43-3.06-1.75-5.16a6.32 6.32 0 01.11-3.62c.42-1 1.54-2.32 5.7-3.19 7.73-1.6 12.64 1.25 13.95-.77.56-.87.09-2.09-.77-4.28a16.43 16.43 0 00-4.17-6",
    className: "showers_before_svg__cls-35"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#754e3e",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.4,
    d: "M689.88 660.11a17.47 17.47 0 006.64.68 18.7 18.7 0 0011.41-5.61"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M735 878.66c.42-1.32 9.3 2.12 24.85 1.71 4.72-.13 7-.53 7.15 0 .25 1-8.2 5.7-17.7 4.76-7.94-.78-14.69-5.27-14.3-6.47zM794.14 914.41c2.75 1 5-.75 8.68-2 8.37-2.94 15.47-.28 15.57-1s-5.94-2.38-12.51-3.07c-3.1-.33-14.31-1.51-15.32 1.53-.48 1.4 1.44 3.73 3.58 4.54zM769.12 887.86c-.44-.37-1.73 1-5.44 2.79-1.37.68-2.5 1.14-3.5 1.55-4.06 1.65-5.39 1.71-5.36 2 .07.72 8.13 2.35 12.26-1.75 1.71-1.7 2.53-4.17 2.04-4.59z",
    className: "showers_before_svg__cls-42"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M758.39 633.3c.34.44-.67 1.49-1.78 3.32a25.72 25.72 0 00-3.32 10c-1.09 6.72 1.13 11 .51 11.23-.79.25-4.84-6.39-4.34-14 .12-1.93.36-4.93 2.55-7.4s5.85-3.83 6.38-3.15z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#dedede",
    opacity: 0.35
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b466e",
    d: "M718.15 622.17v.36l-.08.43c-1.24 3.59-2.06 6-2.56 7.47a19.55 19.55 0 00-.64 1.92c-.48 2.11-.56 3.34-.86 4.95-.53 2.89-.55 2.62-1.66 9.45-.13.81-.29 1.51-.35 1.91a38.29 38.29 0 019.37-7.7 37.87 37.87 0 0110.73-4.21c0-.58 0-1.43-.06-2.46-.13-3.31-.25-5.79-.48-8.67-.32-4.19-.61-7.43-.89-9.82h-.83a14.53 14.53 0 00-3.93.62 15.26 15.26 0 00-3.34 1.5 13.41 13.41 0 00-2.54 1.93 12.76 12.76 0 00-1.51 1.68l-.19.25-.19.27"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "showers_before_svg__Fahrradstellplatz",
    fill: "#515151",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M436.35 942.89h-.58c-7.17-.28-12.73-5.67-12.42-12a168.66 168.66 0 0112.29-52.63c13.69-33.62 37.36-60.39 68.43-77.41 46.87-25.66 93.8-30.34 132.16-13.19 47.9 21.43 74.53 72.15 66.27 126.23-1 6.32-7.52 10.74-14.63 9.89s-12.1-6.68-11.13-13c6.76-44.31-14.21-85.49-52.2-102.48-40.47-18.1-84.3-.11-106.82 12.22-62.81 34.4-68 103.6-68.39 111.38-.33 6.1-6.06 10.99-12.98 10.99z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "showers_before_svg__Wolken"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.26-5.51C67.8-25.59 89.42-39.93 115-39.93c25.21 0 46.67 14 55.43 33.68a45.76 45.76 0 0111.28-1.56c23 0 41.69 16.65 41.69 37.18s-18.66 37.17-41.69 37.17H73.25c-23 0-41.69-16.64-41.69-37.17 0-16.14 11.59-29.73 27.7-34.88zM328.31 55.74C323.4 44.2 311 36 296.33 36c-14.48 0-26.81 8-31.84 19.35a26.39 26.39 0 00-6.48-.9c-13.22 0-23.94 9.56-23.94 21.35S244.79 97.11 258 97.11h62.27c13.22 0 23.94-9.55 23.94-21.35.01-9.26-6.65-17.07-15.9-20.02zM640.71-6.56c9-21.2 31.84-36.34 58.78-36.34 26.62 0 49.28 14.76 58.52 35.56A48.42 48.42 0 01769.92-9c24.31 0 44 17.57 44 39.24s-19.71 39.24-44 39.24H655.48c-24.31 0-44-17.57-44-39.24-.02-17.01 12.22-31.36 29.23-36.8z",
    className: "showers_before_svg__cls-46"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "showers_before_svg__Busch2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M969.76 984.77h-2c-.71 0-1.31-.05-2-.05-22.9 0-41.52-11.85-41.52-26.41 0-12.08 12.73-22.46 30.76-25.51-5.06-4.47-7.81-9.85-7.81-15.42 0-12 12.38-22.28 30.33-25.43a17.2 17.2 0 01-.9-5.42c0-13 14.29-23.74 34.17-26 .88-14.07 19.15-25.35 41.49-25.35a64.28 64.28 0 0111.43 1c7.72-7.33 20.53-11.68 34.48-11.68a59.91 59.91 0 0122.44 4.17c7.12-6.48 18.61-10.63 31.08-11.19 7.69-7.5 20.63-12 34.76-12 22.49 0 40.87 11.44 41.51 25.65 14.39 2.18 26 9.22 30.1 18.26h.2c20.15 0 37 8.92 40.72 21.36 20 .21 36.6 9.2 40.11 21.66 16.67 3.68 27.79 13.62 27.79 24.93 0 6.45-3.55 12.49-10.06 17.27 14.09 4.43 23 13.49 23 23.66 0 12-12.74 22.51-31 25.53h-.12l-377 .86c-.57.08-1.21.11-1.96.11z",
    className: "showers_before_svg__cls-47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.53 807c22.11 0 40 11.16 40 24.92v.53c15.1 1.95 27 9.21 30.66 18.49h1.17c20.17 0 36.8 9.3 39.57 21.37h.45c20.2 0 36.86 9.32 39.59 21.43 16 3.27 27.51 12.62 27.51 23.66 0 7-4.64 13.31-12.1 17.83 14.68 3.69 25.05 12.63 25.05 23.1 0 11.54-12.62 21.22-29.73 24.05l-377 .86a18.42 18.42 0 01-2 .09c-1.29 0-2.56-.09-3.94-.09-22.11 0-40-11.15-40-24.91 0-12.26 14.22-22.42 32.94-24.51-6.2-4.38-10-10.12-10-16.42 0-11.81 13.2-21.67 30.9-24.25a16.24 16.24 0 01-1.47-6.6c0-12.52 14.84-22.85 34.16-24.62v-.3c0-13.76 17.92-24.91 40-24.91a62.72 62.72 0 0111.92 1.12c7.06-7.08 19.62-11.8 34-11.8a57.89 57.89 0 0122.76 4.43c6.71-6.55 18.19-11 31.41-11.48 7-7.15 19.66-11.94 34.11-11.94m0-3c-14.27 0-27.38 4.47-35.39 12-12.2.65-23.46 4.67-30.75 10.93a61.89 61.89 0 00-22.14-3.94c-14 0-26.91 4.3-35 11.58a66.08 66.08 0 00-11-.9c-11.24 0-21.86 2.75-29.89 7.75-7.58 4.72-12.12 11-13 17.76-20 2.63-34.29 13.86-34.29 27.32a18.22 18.22 0 00.51 4.25c-17.8 3.62-29.94 14.24-29.94 26.6 0 5.17 2.16 10.17 6.2 14.5-17.23 3.75-29.15 14.27-29.15 26.43 0 7.73 4.66 14.89 13.13 20.16 8 5 18.65 7.75 29.89 7.75.67 0 1.31 0 1.94.05s1.33 0 2 0 1.44 0 2.08-.09l376.84-.86h.48c19-3.14 32.25-14.25 32.25-27 0-10.19-8.23-19.29-21.44-24.19 5.52-4.77 8.49-10.57 8.49-16.74 0-11.83-11.22-22.21-28.11-26.2-4.11-12.42-20.46-21.36-40.2-21.87-4.47-12.36-21.15-21.16-41.06-21.37-4.55-8.94-15.57-15.66-29.64-18.06-.76-6.93-5.32-13.29-13-18.09-8-5-18.64-7.76-29.89-7.76z",
    className: "showers_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M943.62 969.84c0-12.26 14.22-22.42 33-24.51-6.2-4.38-10-10.12-10-16.43 0-11.8 13.2-21.66 30.89-24.24a16.24 16.24 0 01-1.46-6.61c0-12.51 14.84-22.84 34.16-24.61v-.3c0-13.76 17.92-24.92 40-24.92a62.78 62.78 0 0111.92 1.13c7.06-7.08 19.62-11.8 34-11.8a57.93 57.93 0 0122.76 4.43c6.71-6.55 18.19-11 31.4-11.48 7-7.15 19.67-11.94 34.12-11.94a59.82 59.82 0 0118.4 2.81c-6.38-8.49-20.18-14.38-36.23-14.38-14.45 0-27.08 4.79-34.11 11.94-13.22.48-24.7 4.93-31.41 11.48a57.89 57.89 0 00-22.76-4.43c-14.37 0-26.93 4.72-34 11.8a62.72 62.72 0 00-11.92-1.12c-22.1 0-40 11.15-40 24.91v.3c-19.32 1.77-34.16 12.1-34.16 24.62a16.24 16.24 0 001.47 6.6c-17.7 2.58-30.9 12.44-30.9 24.25 0 6.3 3.79 12 10 16.42-18.72 2.09-33 12.25-33 24.51 0 9.63 8.79 18 21.63 22.11a17.46 17.46 0 01-3.8-10.54z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "showers_before_svg__Busch1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-315.31 891h-3.95c-22.89 0-41.52-11.85-41.52-26.42 0-12.08 12.74-22.46 30.76-25.5-5.06-4.47-7.81-9.86-7.81-15.43 0-12 12.38-22.28 30.34-25.43a17.22 17.22 0 01-.91-5.42c0-13 14.29-23.74 34.17-26 .88-14.07 19.16-25.35 41.49-25.35a65.42 65.42 0 0111.44 1c7.72-7.32 20.53-11.68 34.47-11.68a59.91 59.91 0 0122.44 4.17c7.12-6.48 18.61-10.63 31.09-11.19 7.68-7.5 20.62-12 34.76-12 22.49 0 40.86 11.43 41.51 25.64 14.38 2.19 26 9.22 30.1 18.26h.2c20.15 0 37 8.91 40.72 21.35 20 .21 36.6 9.2 40.11 21.66 16.66 3.68 27.79 13.62 27.79 24.93 0 6.45-3.55 12.49-10.07 17.27 14.09 4.43 23 13.49 23 23.66 0 12-12.74 22.51-31 25.53h-.12l-377 .87c-.63 0-1.27.08-2 .08z",
    className: "showers_before_svg__cls-47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-98.53 713.25c22.1 0 40 11.15 40 24.91v.53c15.09 1.95 27 9.21 30.65 18.49h1.18c20.16 0 36.8 9.29 39.57 21.37h.45c20.2 0 36.85 9.32 39.58 21.43 16 3.27 27.52 12.62 27.52 23.66 0 7-4.65 13.31-12.11 17.83 14.68 3.69 25 12.64 25 23.1 0 11.54-12.62 21.22-29.73 24.05l-377 .87c-.66.06-1.31.08-1.95.08-1.28 0-2.56-.08-3.94-.08-22.1 0-40-11.16-40-24.92 0-12.25 14.22-22.42 32.94-24.5-6.2-4.39-10-10.13-10-16.43 0-11.81 13.2-21.67 30.9-24.24a16.32 16.32 0 01-1.47-6.61c0-12.52 14.85-22.85 34.16-24.62v-.3c0-13.76 17.92-24.91 40-24.91A62.82 62.82 0 01-220.8 744c7.06-7.07 19.62-11.8 34-11.8a57.89 57.89 0 0122.76 4.43c6.71-6.55 18.19-11 31.41-11.48 7-7.15 19.66-11.93 34.12-11.93m0-3c-14.27 0-27.39 4.46-35.4 12-12.19.66-23.45 4.67-30.75 10.93a61.81 61.81 0 00-22.14-3.94c-14 0-26.91 4.3-35 11.58a66.08 66.08 0 00-11-.9c-11.24 0-21.85 2.75-29.88 7.75-7.59 4.72-12.12 11-13 17.76-20 2.63-34.29 13.86-34.29 27.32a18.22 18.22 0 00.51 4.25c-17.8 3.62-29.94 14.24-29.94 26.6 0 5.18 2.17 10.17 6.2 14.5-17.22 3.76-29.15 14.27-29.15 26.43 0 7.73 4.66 14.89 13.14 20.16 8 5 18.64 7.76 29.88 7.76h3.94c.66 0 1.44 0 2.09-.08l376.84-.87h.48c19-3.14 32.24-14.25 32.24-27 0-10.19-8.23-19.28-21.43-24.19 5.51-4.77 8.49-10.57 8.49-16.74 0-11.83-11.22-22.21-28.11-26.2C51.17 785 34.83 776 15.09 775.52 10.62 763.16-6.06 754.36-26 754.15c-4.54-8.94-15.57-15.66-29.64-18.06-.76-6.93-5.31-13.29-13-18.09-8-5-18.65-7.75-29.89-7.75z",
    className: "showers_before_svg__cls-6"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowersbefore);
export default __webpack_public_path__ + "static/media/showers.before.e56ae25d.svg";
export { ForwardRef as ReactComponent };